import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { useParallax } from '@/hooks/use-parallax'
import { useReveal } from '@/hooks/use-reveal'
import { SiteFooter } from '@/components/generals/site-footer'

/**
 * The room the sub-pages sit in: the same grain, vignette and inset frame
 * the hang uses, held fixed so the chrome never scrolls away.
 */
export const PageShell: FC<LayoutProps> = ({ children }): ReactNode => {
    useReveal()
    useParallax()

    return (
        <div className='relative min-h-screen'>
            <div className='mo-chrome-fixed' aria-hidden>
                <div className='mo-grain' />
                <div className='mo-vignette' />
                <div className='mo-frame' />
            </div>

            <main className='ed'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
